import { Routes, Route } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import { Login } from "../views/Login";
import { ForgotPassword } from "../views/ForgotPassword";
import { ResetPassword } from "../views/ResetPassword";
import { UserRegisterAccept } from "../views/UserRegisterAccept";
import { NotFound } from "../views/NotFound";
import { AppBar } from "../components/AppBar";

export function AuthRoutes() {
  return (
    <>
      <AppBar/>
      <Toolbar sx={{ minHeight: 64 }} />
      <Box
        sx={{
          height: "calc(100vh - 64px)",
        }}
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:hash" element={<ResetPassword />} />
          <Route path="/user-register-accept/:hash" element={<UserRegisterAccept />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
    </>
  );
}
